import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import { downloadFile, getExportErrorMessage } from "../../helpers/exportFile";
const qiTransferApi = factory.get("qiTransfer");
const initialState = {
  searchBody: {},
  statuses: [],
  qiTransfer: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
};

export const qiTransferSlice = createSlice({
  name: "qiTransfer",
  initialState,
  reducers: {
    setDataTable: (state, { payload }) => {
      state.qiTransfer.data = payload.data.data;
      state.qiTransfer.total = payload.data.total;
      state.qiTransfer.total_amount = payload.data.total_amount;
    },

    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },

    setStatuses: (state, { payload }) => {
      state.statuses = payload.data.data;
    },

    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const { setLoading, setDataTable, setSearchBody, setStatuses } =
  qiTransferSlice.actions;

export default qiTransferSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("qiTransfer"));
    const res = await qiTransferApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("qiTransfer"));
  } catch (err) {
    dispatch(setLoading("qiTransfer"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const exportExcel = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("qiTransfer"));
    const res = await qiTransferApi.export({
      ...params,
      is_excel: 1,
    });
    await downloadFile(res, `qi_transfer.xlsx`);
    dispatch(setLoading("qiTransfer"));
  } catch (err) {
    dispatch(setLoading("qiTransfer"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getStatuses = () => async (dispatch) => {
  try {
    dispatch(setStatuses(await qiTransferApi.getStatuses()));
  } catch (err) {
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      })
    );
  }
};

export const QiTransfer = {
  getAll,
  getStatuses,
  exportExcel,
};
